import { useEffect, useState } from 'react'

import { CapsLockIndicatorWrapper } from './caps-lock-indicator.styles'

export const CapsLockIndicator = () => {
  const [capsLockActive, setCapsLockActive] = useState(false)

  useEffect(() => {
    // Function to handle keydown events
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.getModifierState('CapsLock')) {
        setCapsLockActive(true)
      }
    }

    // Function to handle keyup events
    const handleKeyUp = (event: KeyboardEvent) => {
      if (!event.getModifierState('CapsLock')) {
        setCapsLockActive(false)
      }
    }

    // Initial check for Caps Lock state
    const initialCheck = () => {
      const event = new KeyboardEvent('keydown', {})
      if (event.getModifierState('CapsLock')) {
        setCapsLockActive(true)
      }
    }

    // Add event listeners when component mounts
    window.addEventListener('keydown', handleKeyDown)
    window.addEventListener('keyup', handleKeyUp)

    // Check Caps Lock initially
    if (typeof document !== 'undefined') {
      document.addEventListener('click', initialCheck, { once: true })
      document.addEventListener('keydown', initialCheck, { once: true })
    }

    // Clean up event listeners when component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('keyup', handleKeyUp)
      if (typeof document !== 'undefined') {
        document.removeEventListener('click', initialCheck)
        document.removeEventListener('keydown', initialCheck)
      }
    }
  }, [])

  if (!capsLockActive) {
    return null
  }

  return (
    <CapsLockIndicatorWrapper data-cy="caps-lock-indicator">
      <span role="alert" aria-live="assertive" style={{ display: 'flex', alignItems: 'center' }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            marginRight: '4px',
            flexShrink: 0,
            display: 'block',
            position: 'relative',
            top: '1px',
          }}
        >
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
        </svg>
        <span style={{ lineHeight: 1 }}>CAPS LOCK ON</span>
      </span>
    </CapsLockIndicatorWrapper>
  )
}
